// Author PanYuRou
// Date 2023-11-03 11:18:08

class EmEmAdmUserGroup {
constructor({
                id = null,
                name = '',
                status = '',
                code = '',
                remark = ''
            }
= {}) {
    this.id = id;
    this.name = name;
    this.status = status;
    this.code = code;
    this.remark = remark;
}
}

function newEntity() {
return new EmEmAdmUserGroup();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.admin.emEmAdmUserGroup.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'name',
        label: 'label.em.admin.emEmAdmUserGroup.grid.name',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
            key: 'status',
            label: 'label.em.admin.emEmAdmUserGroup.grid.status',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '启用'},
                    {value: '2', text: '冻结'}
                ]
            }
        },
        {
            key: 'code',
            label: 'label.em.admin.emEmAdmUserGroup.grid.code',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.em.admin.emEmAdmUserGroup.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ])}

const filter = {
    idFilter: '',
    idListFilter: [],
    nameFilter: '',
    statusFilter: '',
    codeFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'idFilter',
        label: 'label.em.admin.emEmAdmUserGroup.filter.id',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'nameFilter',
        label: 'label.em.admin.emEmAdmUserGroup.filter.name',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'statusFilter',
        label: 'label.em.admin.emEmAdmUserGroup.filter.status',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '启用'},
                {value: '2', text: '冻结'}
            ]
        }
    },
    {
        key: 'codeFilter',
        label: 'label.em.admin.emEmAdmUserGroup.filter.code',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.admin.emEmAdmUserGroup.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'status',
        label: 'label.em.admin.emEmAdmUserGroup.entity.status',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '启用'},
                {value: '2', text: '冻结'}
            ]
        }
        },
        {
            key: 'code',
            label: 'label.em.admin.emEmAdmUserGroup.entity.code',
            sortable: true,
            disabled: false,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.em.admin.emEmAdmUserGroup.entity.remark',
            sortable: true,
            disabled: false,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ]

export {EmEmAdmUserGroup, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
